<template>
  <div class="login-page">
    <img class="bg" src="~@/assets/login/bg.png" alt="">
    <img class="bg-logo" src="~@/assets/login/logo1.png" alt="">
    <div class="form-wrap">
      <div class="login-form">
        <img class="form-logo" src="~@/assets/login/logo2.png" alt="">
        <h1 class="title">{{ commonTitle }}</h1>
        <label class="input-wrap">
          <p class="label">用户名</p>
          <input type="text" v-model="form.username" @keyup.enter="onSubmit">
        </label>
        <label class="input-wrap">
          <p class="label">密码</p>
          <input type="password" v-model="form.password" @keyup.enter="onSubmit">
        </label>
        <label class="input-wrap">
          <p class="label">验证码</p>
          <div class="captcha-wrap">
            <input v-model="form.code" @keyup.enter="onSubmit">
            <img class="code-img" :src="imgUrl" alt="" @click="getCaptcha">
          </div>
        </label>
        <div class="submit-wrap">
          <a-button class="submit-btn" @click="onSubmit" :loading="loading">
            登 录
          </a-button>
          <a-button class="submit-btn" @click="loginOther('loginRuleForm')" :loading="loading" style="background:#07A795;color:#fff;">
            keycloak认证
          </a-button>
          <p class="forget-password" @click="forgetVisible = true">忘记密码？</p>
        </div>
      </div>
      <div class="ViaDownloadDiv">
            <ul>
                  <li>标注工具下载:</li>
                  <!-- <li><a href="preview/2021/wellspringtools/labelImg.exe">WellSpringLabelImg Win10 X64.exe</a></li> -->
                  <li><a href="spring/preview/2023/wellspringtools/labelme.exe">WellSpringLabelMe Win10 X64.exe</a></li>
            </ul>
      </div>
    </div>
  </div>
  <a-modal v-model:visible="forgetVisible" title="忘记密码？" :footer="null"
    class="forget-modal">
    <p>请联系</p>
    <p class="email">jianglin.zhang@westwell-lab.com</p>
    <a-button type="primary" @click="forgetVisible = false">好的</a-button>
  </a-modal>
</template>
<script>
import { getMyUser, getCaptcha, login } from '@/api/user'

let origin = window.location.origin
export default {
  created(){
    if(this.$route.query.token){
      localStorage.setItem('westToken', this.$route.query.token)
      localStorage.setItem('westNewLogin', '1')
      this.$router.push({
        name: 'account'
      })
    }
  },
  data () {
    return {
      redirect_uri: origin + '/auth/social/keycloak_ai/callback',
      login_uri:origin + '/#/login?token={}',
      commonTitle: window.publicConfig.commonTitle,
      loading: false,
      form: {
        username: '',
        password: '',
        code: ''
      },
      imgUrl: '',
      forgetVisible: false
    }
  },
  mounted () {
    this.getCaptcha()
    getMyUser().then(() => {
      this.$router.push({
        name: 'account'
      })
    })
  },
  methods: {
    getCaptcha () {
      getCaptcha().then(res => {
        this.imgUrl = URL.createObjectURL(res.data)
      })
    },
    onSubmit () {
      this.loading = true
      login({
        ...this.form
      }).then(res => {
        const info = res.data
        const accessToken = info.access_token
        localStorage.setItem('westToken', accessToken)
        localStorage.setItem('westNewLogin', '1')
        this.$router.push({
          name: 'account'
        })
        // const refreshToken = info.refresh_token
        // localStorage.get
      }).finally(() => {
        this.loading = false
      })
    },
    loginOther(){
      window.location.href = `${origin}/auth/social/login/keycloak_ai/bindlogin?redirect_uri=${encodeURIComponent(this.redirect_uri)}&login_uri=${encodeURIComponent(this.login_uri)}`;
    }
  }
}
</script>
<style lang="less">
.login-page {
  position: relative;
  height: 100%;
  display: flex;
  .bg {
    flex-shrink: 0;
    height: 100%;
  }
  .bg-logo {
    position: absolute; top: 50px; left: 50px;
    height: 50px;
  }
  .form-wrap {
    padding-bottom: 100px;
    flex-grow: 1; flex-shrink: 1;
    display: flex; flex-direction: column; justify-content: center; align-items: center;
    .ViaDownloadDiv {
      position:fixed; bottom:10px;
      ul{
        list-style: none;
        li{
          width: 100%; float: left; text-align: left;
          a{
            text-decoration: none; font-size: 16px; font-weight: bolder; color: #138496;
          }
        }
      }
    }
    .login-form {
      margin: 0 auto;
      width: 380px;
      text-align: left;
      .form-logo {
        height: 40px;
      }
      .title {
        margin: 10px 0 50px;
        font-size: 40px; letter-spacing: 2px;
      }
      .input-wrap {
        display: block;
        margin-bottom: 30px;
        border-bottom: 1px solid #d9d9d9;
        .captcha-wrap {
          display: flex;
          input {
            width: calc(100% - 120px);
          }
          .code-img {
            width: 120px; min-height: 30px;
            background: #efefef;
          }
        }
      }
      input {
        display: block; margin-top: 10px;
        width: 100%;
        height: 30px; line-height: 30px;
        border: none;
        background: none;
        outline: none;
      }
      input:focus{
        border:none;
      }
      .submit-wrap {
        display: flex; justify-content: space-between; align-items: center;
        .submit-btn {
          padding: 0 30px;
          border-radius: 16px;
          background-color: #01274b; color: #fff;
        }
        .forget-password {
          cursor: pointer;
          font-size: 14px;
          color: @theme;
        }
      }
      .ant-btn:active, .ant-btn.active, .ant-btn:hover {
        border: 1px solid transparent;
      }
    }
  }
}
.forget-modal {
  p {
    text-align: center;
  }
  .email {
    font-size: 18px;
  }
  .ant-btn {
    display: block;
    margin: 30px auto 0;
  }
}
</style>
